var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQuery, useInfiniteQuery } from 'react-query';
function fetcher(client, query, variables, headers) {
    return () => __awaiter(this, void 0, void 0, function* () { return client.request(query, variables, headers); });
}
export var AccountCredentialType;
(function (AccountCredentialType) {
    AccountCredentialType["AnotherCredentialProxy"] = "another_credential_proxy";
    AccountCredentialType["AppCredentialProxy"] = "app_credential_proxy";
    AccountCredentialType["Cookies"] = "cookies";
    AccountCredentialType["GroupToken"] = "group_token";
    AccountCredentialType["GroupTokenNested"] = "group_token_nested";
    AccountCredentialType["InstagramBusiness"] = "instagram_business";
    AccountCredentialType["InstagramLegacy1"] = "instagram_legacy1";
    AccountCredentialType["Oauth1Token"] = "oauth1_token";
    AccountCredentialType["RefreshableToken"] = "refreshable_token";
    AccountCredentialType["Token"] = "token";
})(AccountCredentialType || (AccountCredentialType = {}));
export var AuthType;
(function (AuthType) {
    AuthType["Token"] = "token";
})(AuthType || (AuthType = {}));
/** Feature names correlates with names in relevant mutation input and query output (postproject, post or post comment) */
export var FeatureNameEnum;
(function (FeatureNameEnum) {
    FeatureNameEnum["AsCarousel"] = "as_carousel";
    FeatureNameEnum["AsNote"] = "as_note";
    FeatureNameEnum["AudioSet"] = "audio_set";
    FeatureNameEnum["CommentArchiveAt"] = "comment__archive_at";
    FeatureNameEnum["CommentText"] = "comment__text";
    FeatureNameEnum["CopyrightLink"] = "copyright_link";
    FeatureNameEnum["DisableComments"] = "disable_comments";
    FeatureNameEnum["DisableDuet"] = "disable_duet";
    FeatureNameEnum["DisableFeedPreview"] = "disable_feed_preview";
    FeatureNameEnum["DisableLinkSnippet"] = "disable_link_snippet";
    FeatureNameEnum["DisableStitch"] = "disable_stitch";
    FeatureNameEnum["DisableUtmGenerator"] = "disable_utm_generator";
    FeatureNameEnum["DisableWatermark"] = "disable_watermark";
    FeatureNameEnum["InlineButtons"] = "inline_buttons";
    FeatureNameEnum["InlineButtonsTitleText"] = "inline_buttons__title_text";
    FeatureNameEnum["IsAdvert"] = "is_advert";
    FeatureNameEnum["IsHideOnArchive"] = "is_hide_on_archive";
    FeatureNameEnum["LinkUrl"] = "link_url";
    FeatureNameEnum["NotifyOnPublishingSuccess"] = "notify_on_publishing_success";
    FeatureNameEnum["PaidSubscribersOnlyPeriod"] = "paid_subscribers_only_period";
    FeatureNameEnum["PinPost"] = "pin_post";
    FeatureNameEnum["Place"] = "place";
    FeatureNameEnum["Poll"] = "poll";
    FeatureNameEnum["PollAnonymousAllowVote"] = "poll__anonymous_allow_vote";
    FeatureNameEnum["PollAnswers"] = "poll__answers";
    FeatureNameEnum["PollAnswersText"] = "poll__answers__text";
    FeatureNameEnum["PollQuestionText"] = "poll__question__text";
    FeatureNameEnum["PollResultAfterVoting"] = "poll__result_after_voting";
    FeatureNameEnum["PollSingleChoices"] = "poll__single_choices";
    FeatureNameEnum["PostArchiveAt"] = "post__archive_at";
    FeatureNameEnum["PostLinkInProfile"] = "post_link_in_profile";
    FeatureNameEnum["PrivacyLevel"] = "privacy_level";
    FeatureNameEnum["Text"] = "text";
    FeatureNameEnum["TextOverrideMarkdown"] = "text__override__markdown";
    FeatureNameEnum["Title"] = "title";
    FeatureNameEnum["Topics"] = "topics";
    FeatureNameEnum["Uploads"] = "uploads";
    FeatureNameEnum["UploadsDeferredEdits"] = "uploads__deferred_edits";
    FeatureNameEnum["UploadsHashtags"] = "uploads__hashtags";
    FeatureNameEnum["UploadsPlaces"] = "uploads__places";
    FeatureNameEnum["UploadsPolls"] = "uploads__polls";
    FeatureNameEnum["UploadsUsertags"] = "uploads__usertags";
    FeatureNameEnum["UploadsVideoCoverId"] = "uploads__video_cover_id";
    FeatureNameEnum["UploadsVideoTitle"] = "uploads__video_title";
    FeatureNameEnum["YoutubePrivacyStatus"] = "youtube_privacy_status";
})(FeatureNameEnum || (FeatureNameEnum = {}));
export var InstagramPostTypeEnum;
(function (InstagramPostTypeEnum) {
    InstagramPostTypeEnum["Carousel"] = "CAROUSEL";
    InstagramPostTypeEnum["Photo"] = "PHOTO";
    InstagramPostTypeEnum["Video"] = "VIDEO";
})(InstagramPostTypeEnum || (InstagramPostTypeEnum = {}));
export var InvoiceEntity;
(function (InvoiceEntity) {
    InvoiceEntity["LegalEntity"] = "legal_entity";
    InvoiceEntity["NaturalPerson"] = "natural_person";
})(InvoiceEntity || (InvoiceEntity = {}));
export var Language;
(function (Language) {
    Language["En"] = "en";
    Language["Es"] = "es";
    Language["Kk"] = "kk";
    Language["Pt"] = "pt";
    Language["Ro"] = "ro";
    Language["Ru"] = "ru";
    Language["Uk"] = "uk";
})(Language || (Language = {}));
/** Network service identifier */
export var Medium;
(function (Medium) {
    Medium["Bitly"] = "bitly";
    Medium["Discord"] = "discord";
    Medium["Elama"] = "elama";
    Medium["Facebook"] = "facebook";
    Medium["Google"] = "google";
    Medium["Instagram"] = "instagram";
    Medium["InstagramBusiness"] = "instagram_business";
    Medium["Linkedin"] = "linkedin";
    Medium["Max"] = "max";
    Medium["Mytarget"] = "mytarget";
    Medium["Ok"] = "ok";
    Medium["Pepper"] = "pepper";
    Medium["Periscope"] = "periscope";
    Medium["Pinterest"] = "pinterest";
    Medium["Pushbullet"] = "pushbullet";
    Medium["Rutube"] = "rutube";
    Medium["Slack"] = "slack";
    Medium["Smmplanner"] = "smmplanner";
    Medium["Snapchat"] = "snapchat";
    Medium["Telegram"] = "telegram";
    Medium["TelegramMtproto"] = "telegram_mtproto";
    Medium["Tenchat"] = "tenchat";
    Medium["Tiktok"] = "tiktok";
    Medium["Tumblr"] = "tumblr";
    Medium["Twitter"] = "twitter";
    Medium["Viber"] = "viber";
    Medium["Vk"] = "vk";
    Medium["VkAds"] = "vk_ads";
    Medium["Whatsapp"] = "whatsapp";
    Medium["Yandex"] = "yandex";
    Medium["Youtube"] = "youtube";
})(Medium || (Medium = {}));
/** Pivot point types enum */
export var OverlayPivotEnum;
(function (OverlayPivotEnum) {
    OverlayPivotEnum["Center"] = "CENTER";
    OverlayPivotEnum["TopLeft"] = "TOP_LEFT";
})(OverlayPivotEnum || (OverlayPivotEnum = {}));
/** Color or pseudo color (blur) to fill the added areas */
export var PaddingFillColorEnum;
(function (PaddingFillColorEnum) {
    PaddingFillColorEnum["Blur20"] = "blur20";
    PaddingFillColorEnum["Blur50"] = "blur50";
    PaddingFillColorEnum["Blur100"] = "blur100";
})(PaddingFillColorEnum || (PaddingFillColorEnum = {}));
export var PageType;
(function (PageType) {
    PageType["Bot"] = "bot";
    PageType["Event"] = "event";
    PageType["Group"] = "group";
    PageType["Public"] = "public";
    PageType["User"] = "user";
})(PageType || (PageType = {}));
export var PlaceExternalIdSourceEnum;
(function (PlaceExternalIdSourceEnum) {
    /** Workaround for blank source (blank enum name leads to schema introspection error) */
    PlaceExternalIdSourceEnum["Blank"] = "blank";
    /** Source for Facebook and Instagram places */
    PlaceExternalIdSourceEnum["FacebookPlaces"] = "facebook_places";
})(PlaceExternalIdSourceEnum || (PlaceExternalIdSourceEnum = {}));
/** "igtv" is deprecated and now it is included into the "feed" */
export var PostDisplayKindEnum;
(function (PostDisplayKindEnum) {
    /** Regular kind of posts but looks like carousel. */
    PostDisplayKindEnum["Carousel"] = "carousel";
    /** TikTok-like kind of posts. Similar to "Reels" in terms of Instagram. May fail or fallback to "feed" if social media dont support such kind of content (depends on our post-policy). */
    PostDisplayKindEnum["Clip"] = "clip";
    /** Regular kind of posts which is displayed at social media's common news feeds. */
    PostDisplayKindEnum["Feed"] = "feed";
    /** Kind of posts which will be published like Instagram "Stories".May fail or fallback to "feed" if social media dont support such kind of content (depends on our post-policy). */
    PostDisplayKindEnum["Story"] = "story";
})(PostDisplayKindEnum || (PostDisplayKindEnum = {}));
export var PostListVariant;
(function (PostListVariant) {
    PostListVariant["Instaview"] = "instaview";
    PostListVariant["List"] = "list";
    PostListVariant["Week"] = "week";
})(PostListVariant || (PostListVariant = {}));
/**
 * PostProject have single internal data structure with multiple API representations for different UI-editors:
 * - Editor Format `default` - is a common format which have a complete support in GraphQL.
 * - Editor Format `story_creator_v1` - is a special representation which is used for special UI-editor "Story Creator (Constructor)". - Editor Format `story_creator_v2` - is same as v1, but supports multiple stories in single project It has several additional attributes for UI-editor private data. These additional fields is not represented in GraphQL at the moment of writing this text, which means that this format is not completely supported: YOU CAN ONLY READ (QUERY) IT, WRITE (MUTATION) ATTEMPTS WILL BE REJECTED to avoid data corruption.
 */
export var PostProjectEditorFormatEnum;
(function (PostProjectEditorFormatEnum) {
    PostProjectEditorFormatEnum["Default"] = "default";
    PostProjectEditorFormatEnum["StoryCreatorV1"] = "story_creator_v1";
    PostProjectEditorFormatEnum["StoryCreatorV2"] = "story_creator_v2";
})(PostProjectEditorFormatEnum || (PostProjectEditorFormatEnum = {}));
/** Alternative "kind" to be used for Instagram posts only */
export var PostProjectOverridesInstagramKind;
(function (PostProjectOverridesInstagramKind) {
    PostProjectOverridesInstagramKind["Clip"] = "clip";
    PostProjectOverridesInstagramKind["Feed"] = "feed";
    PostProjectOverridesInstagramKind["Story"] = "story";
})(PostProjectOverridesInstagramKind || (PostProjectOverridesInstagramKind = {}));
/** Alternative "kind" to be used for Instagram_business posts only */
export var PostProjectOverridesInstagram_BusinessKind;
(function (PostProjectOverridesInstagram_BusinessKind) {
    PostProjectOverridesInstagram_BusinessKind["Clip"] = "clip";
    PostProjectOverridesInstagram_BusinessKind["Feed"] = "feed";
    PostProjectOverridesInstagram_BusinessKind["Story"] = "story";
})(PostProjectOverridesInstagram_BusinessKind || (PostProjectOverridesInstagram_BusinessKind = {}));
/** Alternative "kind" to be used for Ok posts only */
export var PostProjectOverridesOkKind;
(function (PostProjectOverridesOkKind) {
    PostProjectOverridesOkKind["Feed"] = "feed";
    PostProjectOverridesOkKind["Story"] = "story";
})(PostProjectOverridesOkKind || (PostProjectOverridesOkKind = {}));
/** Alternative "kind" to be used for Telegram_mtproto posts only */
export var PostProjectOverridesTelegram_MtprotoKind;
(function (PostProjectOverridesTelegram_MtprotoKind) {
    PostProjectOverridesTelegram_MtprotoKind["Story"] = "story";
})(PostProjectOverridesTelegram_MtprotoKind || (PostProjectOverridesTelegram_MtprotoKind = {}));
export var PostProjectOverridesTextFormatting;
(function (PostProjectOverridesTextFormatting) {
    PostProjectOverridesTextFormatting["Markdown"] = "markdown";
    PostProjectOverridesTextFormatting["PlainText"] = "plain_text";
})(PostProjectOverridesTextFormatting || (PostProjectOverridesTextFormatting = {}));
/** Alternative "kind" to be used for Tiktok posts only */
export var PostProjectOverridesTiktokKind;
(function (PostProjectOverridesTiktokKind) {
    PostProjectOverridesTiktokKind["Clip"] = "clip";
    PostProjectOverridesTiktokKind["Feed"] = "feed";
})(PostProjectOverridesTiktokKind || (PostProjectOverridesTiktokKind = {}));
/** Alternative "kind" to be used for Vk posts only */
export var PostProjectOverridesVkKind;
(function (PostProjectOverridesVkKind) {
    PostProjectOverridesVkKind["Carousel"] = "carousel";
    PostProjectOverridesVkKind["Story"] = "story";
})(PostProjectOverridesVkKind || (PostProjectOverridesVkKind = {}));
/** Alternative "kind" to be used for Youtube posts only */
export var PostProjectOverridesYoutubeKind;
(function (PostProjectOverridesYoutubeKind) {
    PostProjectOverridesYoutubeKind["Clip"] = "clip";
    PostProjectOverridesYoutubeKind["Feed"] = "feed";
})(PostProjectOverridesYoutubeKind || (PostProjectOverridesYoutubeKind = {}));
/** Describes Post state in (scheduled)->(published|error)->(archived) life-cycle */
export var PostStatusEnum;
(function (PostStatusEnum) {
    /** Post has been successfully published and removed from social media. */
    PostStatusEnum["Archived"] = "archived";
    /** There is an error occurrred while trying to publish post. */
    PostStatusEnum["Error"] = "error";
    /** Post has been successfully published to social media. */
    PostStatusEnum["Published"] = "published";
    /** Post is scheduled to be published at some time in the future. Initial state for any Post which is just created (scheduled) by user. */
    PostStatusEnum["Scheduled"] = "scheduled";
})(PostStatusEnum || (PostStatusEnum = {}));
export var RuleTextLengthMethodEnum;
(function (RuleTextLengthMethodEnum) {
    /** Getting text length as unicode graphemes count */
    RuleTextLengthMethodEnum["Grapheme"] = "grapheme";
    /** Getting text length as unicode characters count */
    RuleTextLengthMethodEnum["Plain"] = "plain";
    /** Getting text length as it done by Twitter */
    RuleTextLengthMethodEnum["Tweet"] = "tweet";
})(RuleTextLengthMethodEnum || (RuleTextLengthMethodEnum = {}));
export var SecurityCodeStatusEnum;
(function (SecurityCodeStatusEnum) {
    SecurityCodeStatusEnum["Absent"] = "absent";
    SecurityCodeStatusEnum["Pending"] = "pending";
})(SecurityCodeStatusEnum || (SecurityCodeStatusEnum = {}));
export var UiTheme;
(function (UiTheme) {
    UiTheme["Dark"] = "dark";
    UiTheme["Light"] = "light";
})(UiTheme || (UiTheme = {}));
export var ViolationRecoveryEnum;
(function (ViolationRecoveryEnum) {
    /** post will be published with some degradation (e.g. video quality loss, duration trim & etc) */
    ViolationRecoveryEnum["Degradation"] = "degradation";
    /** Violation recovery is not possible, post publication will be failed (it should be restricted to create such posts) */
    ViolationRecoveryEnum["Error"] = "error";
    /** just notify user about some insignificant details (e.g. gif will be published as video) */
    ViolationRecoveryEnum["Info"] = "info";
    /** post will be published, but some incompatible or extra content will be ignored (e.g. extra images) */
    ViolationRecoveryEnum["Skip"] = "skip";
})(ViolationRecoveryEnum || (ViolationRecoveryEnum = {}));
export const PostProjectOverridesFragmentDoc = `
    fragment PostProjectOverrides on PostProject {
  overrides {
    instagram {
      link_url
      kind
    }
    instagram_business {
      link_url
      kind
    }
    ok {
      link_url
      kind
    }
    vk {
      link_url
      kind
    }
    telegram {
      link_url
      text {
        text
        formatting
      }
    }
    tenchat {
      link_url
      text {
        text
        formatting
      }
    }
    max {
      link_url
      text {
        text
        formatting
      }
    }
    telegram_mtproto {
      kind
    }
  }
}
    `;
export const SocialPageGroupSettingsFragmentDoc = `
    fragment SocialPageGroupSettings on SocialPageGroup {
  utm {
    id
    is_enabled
    tzname
    utm_campaign
    utm_content
    utm_medium
    utm_source
    utm_term
    url_shortener_id
  }
  templates {
    signs {
      id
      name
      text
    }
    comment {
      hashtagsOptional
      hashtagsRequired
      isHashtagsRequiredEnabled
      limit
      order
      placement
    }
    post {
      hashtagsOptional
      hashtagsRequired
      isHashtagsRequiredEnabled
      limit
      order
      placement
    }
  }
  settings {
    aspect_ratio
  }
  watermark {
    id
  }
  post_time_set {
    id
    minute
    weekday
  }
}
    `;
export const SocialPageConfigSettingsFragmentDoc = `
    fragment SocialPageConfigSettings on PageConfig {
  utm {
    id
    is_enabled
    tzname
    utm_campaign
    utm_content
    utm_medium
    utm_source
    utm_term
    url_shortener_id
  }
  settings {
    aspect_ratio
    is_auto_pass_challenge
    is_retry_publish
  }
  watermark {
    id
  }
  post_time_set {
    id
    minute
    weekday
  }
}
    `;
export const SocialPageGroupPageConfigFragmentDoc = `
    fragment SocialPageGroupPageConfig on PageConfig {
  id
  external_id
  medium
  name
  page {
    id
    name
    extra_data {
      logo
      screen_name
      is_business
      is_private
    }
    type
    external_id
  }
  pageconfigaccount_set {
    id
    has_publish_permission
    priority
    account {
      id
      credential {
        id
        account_page {
          id
          name
          extra_data {
            logo
          }
        }
      }
    }
    updated_at
  }
  group {
    id
    name
  }
  ...SocialPageConfigSettings
}
    ${SocialPageConfigSettingsFragmentDoc}`;
export const SocialPageGroupOrganizationFragmentDoc = `
    fragment SocialPageGroupOrganization on Organization {
  id
  is_active
  role
  name
  owner {
    email
    id
  }
}
    `;
export const AddFavPlaceDocument = `
    mutation AddFavPlace($input: PlaceInput!) {
  addFavPlace(input: $input) {
    external_id
    address
    external_id_source
    lat
    lng
    name
    id
  }
}
    `;
export const useAddFavPlaceMutation = (client, options, headers) => useMutation(['AddFavPlace'], (variables) => fetcher(client, AddFavPlaceDocument, variables, headers)(), options);
export const AddPageConfigDocument = `
    mutation AddPageConfig($input: AddPageConfigInputArgs) {
  addPageConfig(input: $input) {
    id
  }
}
    `;
export const useAddPageConfigMutation = (client, options, headers) => useMutation(['AddPageConfig'], (variables) => fetcher(client, AddPageConfigDocument, variables, headers)(), options);
export const AddPostProjectDocument = `
    mutation AddPostProject($input: PostProjectInputArgs) {
  addPostProject(input: $input) {
    id
  }
}
    `;
export const useAddPostProjectMutation = (client, options, headers) => useMutation(['AddPostProject'], (variables) => fetcher(client, AddPostProjectDocument, variables, headers)(), options);
export const AddPostsDocument = `
    mutation AddPosts($input: AddPostsToPostProjectMutationInputArgs) {
  addPosts(input: $input) {
    id
  }
}
    `;
export const useAddPostsMutation = (client, options, headers) => useMutation(['AddPosts'], (variables) => fetcher(client, AddPostsDocument, variables, headers)(), options);
export const AddSocialPageGroupDocument = `
    mutation AddSocialPageGroup($input: SocialPageGroupInputArgs) {
  addSocialPageGroup(input: $input) {
    id
    is_locked_for_update
    name
    pageconfig_set {
      ...SocialPageGroupPageConfig
    }
    organization {
      ...SocialPageGroupOrganization
    }
    ...SocialPageGroupSettings
  }
}
    ${SocialPageGroupPageConfigFragmentDoc}
${SocialPageGroupOrganizationFragmentDoc}
${SocialPageGroupSettingsFragmentDoc}`;
export const useAddSocialPageGroupMutation = (client, options, headers) => useMutation(['AddSocialPageGroup'], (variables) => fetcher(client, AddSocialPageGroupDocument, variables, headers)(), options);
export const ChangePageConfigDocument = `
    mutation ChangePageConfig($input: ChangePageConfigInputArgs, $id: Int!) {
  changePageConfig(input: $input, id: $id) {
    id
  }
}
    `;
export const useChangePageConfigMutation = (client, options, headers) => useMutation(['ChangePageConfig'], (variables) => fetcher(client, ChangePageConfigDocument, variables, headers)(), options);
export const ChangePostFavoriteDocument = `
    mutation ChangePostFavorite($input: PostFavoriteInputArgs) {
  changePostFavorite(input: $input) {
    id
    favorite
  }
}
    `;
export const useChangePostFavoriteMutation = (client, options, headers) => useMutation(['ChangePostFavorite'], (variables) => fetcher(client, ChangePostFavoriteDocument, variables, headers)(), options);
export const ChangePostProjectDocument = `
    mutation ChangePostProject($input: PostProjectInputArgs, $id: Int!, $is_draft: Boolean) {
  changePostProject(input: $input, id: $id, is_draft: $is_draft) {
    id
  }
}
    `;
export const useChangePostProjectMutation = (client, options, headers) => useMutation(['ChangePostProject'], (variables) => fetcher(client, ChangePostProjectDocument, variables, headers)(), options);
export const ChangePostProjectFavoriteDocument = `
    mutation ChangePostProjectFavorite($input: FavoritePostProjectInputArgs) {
  changePostProjectFavorite(input: $input) {
    id
  }
}
    `;
export const useChangePostProjectFavoriteMutation = (client, options, headers) => useMutation(['ChangePostProjectFavorite'], (variables) => fetcher(client, ChangePostProjectFavoriteDocument, variables, headers)(), options);
export const ChangeSocialPageGroupDocument = `
    mutation ChangeSocialPageGroup($input: ChangeSocialPageGroupInputArgs, $id: Int!) {
  changeSocialPageGroup(input: $input, id: $id) {
    id
  }
}
    `;
export const useChangeSocialPageGroupMutation = (client, options, headers) => useMutation(['ChangeSocialPageGroup'], (variables) => fetcher(client, ChangeSocialPageGroupDocument, variables, headers)(), options);
export const DeleteCommmentDocument = `
    mutation DeleteCommment($input: CommentMutationInputArgs) {
  deleteComment(input: $input) {
    comment_id
  }
}
    `;
export const useDeleteCommmentMutation = (client, options, headers) => useMutation(['DeleteCommment'], (variables) => fetcher(client, DeleteCommmentDocument, variables, headers)(), options);
export const DeleteFavPlaceDocument = `
    mutation DeleteFavPlace($input: DeleteFavPlaceInputArgs!) {
  deleteFavPlace(input: $input) {
    id
  }
}
    `;
export const useDeleteFavPlaceMutation = (client, options, headers) => useMutation(['DeleteFavPlace'], (variables) => fetcher(client, DeleteFavPlaceDocument, variables, headers)(), options);
export const DeletePageConfigDocument = `
    mutation DeletePageConfig($id: Int!, $pageconfig_to_transfer_posts: Int) {
  deletePageConfig(
    id: $id
    pageconfig_to_transfer_posts: $pageconfig_to_transfer_posts
  ) {
    id
  }
}
    `;
export const useDeletePageConfigMutation = (client, options, headers) => useMutation(['DeletePageConfig'], (variables) => fetcher(client, DeletePageConfigDocument, variables, headers)(), options);
export const DeletePostProjectDocument = `
    mutation DeletePostProject($id: Int!, $is_draft: Boolean) {
  deletePostProject(id: $id, is_draft: $is_draft) {
    id
  }
}
    `;
export const useDeletePostProjectMutation = (client, options, headers) => useMutation(['DeletePostProject'], (variables) => fetcher(client, DeletePostProjectDocument, variables, headers)(), options);
export const DeletePostsDocument = `
    mutation DeletePosts($input: DeletePostsFromPostProjectMutationInputArgs) {
  deletePosts(input: $input) {
    id
  }
}
    `;
export const useDeletePostsMutation = (client, options, headers) => useMutation(['DeletePosts'], (variables) => fetcher(client, DeletePostsDocument, variables, headers)(), options);
export const DeleteSocialPageGroupDocument = `
    mutation DeleteSocialPageGroup($id: Int!, $social_page_group_to_transfer_posts: Int) {
  deleteSocialPageGroup(
    id: $id
    social_page_group_to_transfer_posts: $social_page_group_to_transfer_posts
  ) {
    id
  }
}
    `;
export const useDeleteSocialPageGroupMutation = (client, options, headers) => useMutation(['DeleteSocialPageGroup'], (variables) => fetcher(client, DeleteSocialPageGroupDocument, variables, headers)(), options);
export const DuplicatePostProjectDocument = `
    mutation DuplicatePostProject($input: DuplicatePostProjectInputArgs) {
  duplicatePostProject(input: $input) {
    id
  }
}
    `;
export const useDuplicatePostProjectMutation = (client, options, headers) => useMutation(['DuplicatePostProject'], (variables) => fetcher(client, DuplicatePostProjectDocument, variables, headers)(), options);
export const RetryArchiveCommentDocument = `
    mutation RetryArchiveComment($input: CommentMutationInputArgs) {
  retryArchiveComment(input: $input) {
    status
    scheduled_for
    archive_at
    id
    commentproject {
      id
    }
    external_id
    post {
      id
    }
  }
}
    `;
export const useRetryArchiveCommentMutation = (client, options, headers) => useMutation(['RetryArchiveComment'], (variables) => fetcher(client, RetryArchiveCommentDocument, variables, headers)(), options);
export const RetryArchivePostDocument = `
    mutation RetryArchivePost($input: ArchivePostMutationInputArgs) {
  retryArchivePost(input: $input) {
    id
  }
}
    `;
export const useRetryArchivePostMutation = (client, options, headers) => useMutation(['RetryArchivePost'], (variables) => fetcher(client, RetryArchivePostDocument, variables, headers)(), options);
export const RetryCommentDocument = `
    mutation RetryComment($input: CommentMutationInputArgs) {
  retryComment(input: $input) {
    status
    scheduled_for
    archive_at
    id
    commentproject {
      id
    }
    external_id
  }
}
    `;
export const useRetryCommentMutation = (client, options, headers) => useMutation(['RetryComment'], (variables) => fetcher(client, RetryCommentDocument, variables, headers)(), options);
export const RetryPostDocument = `
    mutation RetryPost($input: RetryPostMutationInputArgs) {
  retryPost(input: $input) {
    archived
    archive_at
    id
    scheduled_for
    is_draft
    comment {
      archive_at
      error
      is_archived
      text
    }
    error
    display_kind
    display_page_logo_url
    display_page_title
    publishing_status
    organization {
      id
    }
    favorite
    page_config {
      name
      medium
    }
    project {
      text
      place {
        id
        name
        address
      }
      editor_format
      link_url
      poll {
        id
        question
        variants {
          title
        }
      }
      id
      uploads {
        id
        thumb
        mimetype
        url
        mimetype_original
        is_processing
      }
      audio_set {
        id
        title
        artist
      }
    }
    share
  }
}
    `;
export const useRetryPostMutation = (client, options, headers) => useMutation(['RetryPost'], (variables) => fetcher(client, RetryPostDocument, variables, headers)(), options);
export const SetInvoiceDetailsLegalDocument = `
    mutation SetInvoiceDetailsLegal($input: SetInvoiceDetailsLegalInput) {
  setInvoiceDetailsLegal(input: $input) {
    legal_entity {
      vat_id
      address
      last_name
      first_name
      country
      postal_code
      city
      organization_name
    }
  }
}
    `;
export const useSetInvoiceDetailsLegalMutation = (client, options, headers) => useMutation(['SetInvoiceDetailsLegal'], (variables) => fetcher(client, SetInvoiceDetailsLegalDocument, variables, headers)(), options);
export const SetInvoiceDetailsNaturalDocument = `
    mutation SetInvoiceDetailsNatural($input: SetInvoiceDetailsNaturalInput) {
  setInvoiceDetailsNatural(input: $input) {
    natural_person {
      vat_id
      address
      first_name
      last_name
      postal_code
      city
      country
    }
  }
}
    `;
export const useSetInvoiceDetailsNaturalMutation = (client, options, headers) => useMutation(['SetInvoiceDetailsNatural'], (variables) => fetcher(client, SetInvoiceDetailsNaturalDocument, variables, headers)(), options);
export const SharePostDocument = `
    mutation SharePost($input: SharePostInputArgs) {
  sharePost(input: $input) {
    id
    share
  }
}
    `;
export const useSharePostMutation = (client, options, headers) => useMutation(['SharePost'], (variables) => fetcher(client, SharePostDocument, variables, headers)(), options);
export const StopArchivingCommentDocument = `
    mutation StopArchivingComment($input: CommentMutationInputArgs) {
  stopArchivingComment(input: $input) {
    status
    scheduled_for
    archive_at
    id
    commentproject {
      id
    }
    external_id
    post {
      id
    }
  }
}
    `;
export const useStopArchivingCommentMutation = (client, options, headers) => useMutation(['StopArchivingComment'], (variables) => fetcher(client, StopArchivingCommentDocument, variables, headers)(), options);
export const StopArchivingPostDocument = `
    mutation StopArchivingPost($input: ArchivePostMutationInputArgs) {
  stopArchivingPost(input: $input) {
    id
  }
}
    `;
export const useStopArchivingPostMutation = (client, options, headers) => useMutation(['StopArchivingPost'], (variables) => fetcher(client, StopArchivingPostDocument, variables, headers)(), options);
export const UnsharePostDocument = `
    mutation UnsharePost($input: SharePostInputArgs) {
  unsharePost(input: $input) {
    post_id
  }
}
    `;
export const useUnsharePostMutation = (client, options, headers) => useMutation(['UnsharePost'], (variables) => fetcher(client, UnsharePostDocument, variables, headers)(), options);
export const UpdateArchivingPostDocument = `
    mutation UpdateArchivingPost($input: UpdateArchivePostMutationInputArgs) {
  updateArchivingPost(input: $input) {
    id
  }
}
    `;
export const useUpdateArchivingPostMutation = (client, options, headers) => useMutation(['UpdateArchivingPost'], (variables) => fetcher(client, UpdateArchivingPostDocument, variables, headers)(), options);
export const AccountCredentialSetDocument = `
    query AccountCredentialSet($medium: Medium, $medium__in: [Medium!]) {
  account_credential_set(medium: $medium, medium__in: $medium__in) {
    edges {
      node {
        id
        medium
        account_page {
          external_id
        }
        subscription_set {
          page {
            external_id
            name
            extra_data {
              logo
            }
          }
        }
      }
    }
  }
}
    `;
export const useAccountCredentialSetQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['AccountCredentialSet'] : ['AccountCredentialSet', variables], fetcher(client, AccountCredentialSetDocument, variables, headers), options);
useAccountCredentialSetQuery.getKey = (variables) => variables === undefined ? ['AccountCredentialSet'] : ['AccountCredentialSet', variables];
;
export const useInfiniteAccountCredentialSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['AccountCredentialSet.infinite'] : ['AccountCredentialSet.infinite', variables], (metaData) => { var _a; return fetcher(client, AccountCredentialSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteAccountCredentialSetQuery.getKey = (variables) => variables === undefined ? ['AccountCredentialSet.infinite'] : ['AccountCredentialSet.infinite', variables];
;
export const ErrorDocument = `
    query Error($id: Int!) {
  error(id: $id) {
    action
    class_id
    title
    body
    sent_at
    id
    end_at
    level
  }
}
    `;
export const useErrorQuery = (client, variables, options, headers) => useQuery(['Error', variables], fetcher(client, ErrorDocument, variables, headers), options);
useErrorQuery.getKey = (variables) => ['Error', variables];
;
export const useInfiniteErrorQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['Error.infinite', variables], (metaData) => { var _a; return fetcher(client, ErrorDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteErrorQuery.getKey = (variables) => ['Error.infinite', variables];
;
export const FavplaceDocument = `
    query Favplace {
  favplace {
    external_id
    address
    external_id_source
    lat
    lng
    name
    id
  }
}
    `;
export const useFavplaceQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['Favplace'] : ['Favplace', variables], fetcher(client, FavplaceDocument, variables, headers), options);
useFavplaceQuery.getKey = (variables) => variables === undefined ? ['Favplace'] : ['Favplace', variables];
;
export const useInfiniteFavplaceQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['Favplace.infinite'] : ['Favplace.infinite', variables], (metaData) => { var _a; return fetcher(client, FavplaceDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteFavplaceQuery.getKey = (variables) => variables === undefined ? ['Favplace.infinite'] : ['Favplace.infinite', variables];
;
export const InstagramPostSetDocument = `
    query InstagramPostSet($page_size: Int, $cursor: String, $ordering: String, $page_config_id: Int!) {
  instagram_post_set(
    page_size: $page_size
    cursor: $cursor
    ordering: $ordering
    page_config_id: $page_config_id
  ) {
    edges {
      node {
        created_at
        comment_count
        id
        text
        like_count
        media {
          width
          height
          versions_image {
            url
          }
          versions_video {
            url
          }
        }
        media_type
      }
    }
    page_info {
      cursor_next
      cursor_previous
    }
  }
}
    `;
export const useInstagramPostSetQuery = (client, variables, options, headers) => useQuery(['InstagramPostSet', variables], fetcher(client, InstagramPostSetDocument, variables, headers), options);
useInstagramPostSetQuery.getKey = (variables) => ['InstagramPostSet', variables];
;
export const useInfiniteInstagramPostSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['InstagramPostSet.infinite', variables], (metaData) => { var _a; return fetcher(client, InstagramPostSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteInstagramPostSetQuery.getKey = (variables) => ['InstagramPostSet.infinite', variables];
;
export const InstagramUserSetSearchDocument = `
    query InstagramUserSetSearch($username: String!) {
  instagram_user_set_search(username: $username) {
    id
    username
    full_name
    logo
  }
}
    `;
export const useInstagramUserSetSearchQuery = (client, variables, options, headers) => useQuery(['InstagramUserSetSearch', variables], fetcher(client, InstagramUserSetSearchDocument, variables, headers), options);
useInstagramUserSetSearchQuery.getKey = (variables) => ['InstagramUserSetSearch', variables];
;
export const useInfiniteInstagramUserSetSearchQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['InstagramUserSetSearch.infinite', variables], (metaData) => { var _a; return fetcher(client, InstagramUserSetSearchDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteInstagramUserSetSearchQuery.getKey = (variables) => ['InstagramUserSetSearch.infinite', variables];
;
export const InvoiceDetailsDocument = `
    query InvoiceDetails {
  invoice_details {
    legal_entity {
      vat_id
      address
      last_name
      first_name
      country
      postal_code
      city
      organization_name
    }
    natural_person {
      vat_id
      address
      first_name
      last_name
      postal_code
      city
      country
    }
    invoice_entity
  }
}
    `;
export const useInvoiceDetailsQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['InvoiceDetails'] : ['InvoiceDetails', variables], fetcher(client, InvoiceDetailsDocument, variables, headers), options);
useInvoiceDetailsQuery.getKey = (variables) => variables === undefined ? ['InvoiceDetails'] : ['InvoiceDetails', variables];
;
export const useInfiniteInvoiceDetailsQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['InvoiceDetails.infinite'] : ['InvoiceDetails.infinite', variables], (metaData) => { var _a; return fetcher(client, InvoiceDetailsDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteInvoiceDetailsQuery.getKey = (variables) => variables === undefined ? ['InvoiceDetails.infinite'] : ['InvoiceDetails.infinite', variables];
;
export const MyLocationDocument = `
    query MyLocation {
  my_location {
    lat
    lng
  }
}
    `;
export const useMyLocationQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['MyLocation'] : ['MyLocation', variables], fetcher(client, MyLocationDocument, variables, headers), options);
useMyLocationQuery.getKey = (variables) => variables === undefined ? ['MyLocation'] : ['MyLocation', variables];
;
export const useInfiniteMyLocationQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['MyLocation.infinite'] : ['MyLocation.infinite', variables], (metaData) => { var _a; return fetcher(client, MyLocationDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteMyLocationQuery.getKey = (variables) => variables === undefined ? ['MyLocation.infinite'] : ['MyLocation.infinite', variables];
;
export const NextPostTimeSetDocument = `
    query NextPostTimeSet($page_config_ids: [Int!]!) {
  next_post_time_set(page_config_ids: $page_config_ids) {
    page_config_id
    time
  }
}
    `;
export const useNextPostTimeSetQuery = (client, variables, options, headers) => useQuery(['NextPostTimeSet', variables], fetcher(client, NextPostTimeSetDocument, variables, headers), options);
useNextPostTimeSetQuery.getKey = (variables) => ['NextPostTimeSet', variables];
;
export const useInfiniteNextPostTimeSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['NextPostTimeSet.infinite', variables], (metaData) => { var _a; return fetcher(client, NextPostTimeSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteNextPostTimeSetQuery.getKey = (variables) => ['NextPostTimeSet.infinite', variables];
;
export const OrganizationSetDocument = `
    query OrganizationSet($id__in: [Int!], $ordering: String) {
  organization_set(id__in: $id__in, ordering: $ordering) {
    id
    is_active
    members_count
    name
    role
    owner {
      id
      active_plan_group_id
      active_plan_id
      email
      first_name
      last_name
    }
  }
}
    `;
export const useOrganizationSetQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['OrganizationSet'] : ['OrganizationSet', variables], fetcher(client, OrganizationSetDocument, variables, headers), options);
useOrganizationSetQuery.getKey = (variables) => variables === undefined ? ['OrganizationSet'] : ['OrganizationSet', variables];
;
export const useInfiniteOrganizationSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['OrganizationSet.infinite'] : ['OrganizationSet.infinite', variables], (metaData) => { var _a; return fetcher(client, OrganizationSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteOrganizationSetQuery.getKey = (variables) => variables === undefined ? ['OrganizationSet.infinite'] : ['OrganizationSet.infinite', variables];
;
export const PageConfigSetDocument = `
    query PageConfigSet($label: [String!], $medium: Medium, $cursor: String, $group: Int, $group__in: [Int!], $has_publish_permission: Boolean, $has_posts: Boolean, $id__in: [Int!], $ordering: String, $has_scheduled_posts: Boolean, $medium__in: [String!], $medium_external_id: String, $medium_external_id__in: [String!], $all_organization_contexts: Boolean, $page_size: Int) {
  page_config_set(
    label: $label
    medium: $medium
    cursor: $cursor
    group: $group
    group__in: $group__in
    has_publish_permission: $has_publish_permission
    has_posts: $has_posts
    id__in: $id__in
    ordering: $ordering
    has_scheduled_posts: $has_scheduled_posts
    medium__in: $medium__in
    medium_external_id: $medium_external_id
    medium_external_id__in: $medium_external_id__in
    all_organization_contexts: $all_organization_contexts
    page_size: $page_size
  ) {
    edges {
      node {
        id
        external_id
        medium
        name
        pageconfigaccount_set {
          id
          has_publish_permission
          priority
          account {
            id
            credential {
              id
              account_page {
                id
                name
                extra_data {
                  logo
                }
              }
            }
          }
          updated_at
        }
        group {
          id
          name
          post_time_set {
            id
            weekday
            minute
          }
          templates {
            comment {
              order
              placement
              hashtagsOptional
              hashtagsRequired
              isHashtagsRequiredEnabled
              limit
            }
            post {
              order
              placement
              hashtagsOptional
              hashtagsRequired
              isHashtagsRequiredEnabled
              limit
            }
            signs {
              id
              name
              text
            }
          }
          watermark {
            id
          }
          utm {
            is_enabled
          }
        }
        page {
          id
          name
          extra_data {
            logo
            screen_name
            is_business
            is_private
          }
          type
          external_id
        }
        ...SocialPageConfigSettings
      }
    }
    page_info {
      cursor_next
      cursor_previous
    }
  }
}
    ${SocialPageConfigSettingsFragmentDoc}`;
export const usePageConfigSetQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['PageConfigSet'] : ['PageConfigSet', variables], fetcher(client, PageConfigSetDocument, variables, headers), options);
usePageConfigSetQuery.getKey = (variables) => variables === undefined ? ['PageConfigSet'] : ['PageConfigSet', variables];
;
export const useInfinitePageConfigSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['PageConfigSet.infinite'] : ['PageConfigSet.infinite', variables], (metaData) => { var _a; return fetcher(client, PageConfigSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePageConfigSetQuery.getKey = (variables) => variables === undefined ? ['PageConfigSet.infinite'] : ['PageConfigSet.infinite', variables];
;
export const PlaceSetSearchDocument = `
    query PlaceSetSearch($query: String, $lat: Float!, $lng: Float!) {
  place_set_search(query: $query, lat: $lat, lng: $lng) {
    address
    external_id
    external_id_source
    name
    lat
    lng
  }
}
    `;
export const usePlaceSetSearchQuery = (client, variables, options, headers) => useQuery(['PlaceSetSearch', variables], fetcher(client, PlaceSetSearchDocument, variables, headers), options);
usePlaceSetSearchQuery.getKey = (variables) => ['PlaceSetSearch', variables];
;
export const useInfinitePlaceSetSearchQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['PlaceSetSearch.infinite', variables], (metaData) => { var _a; return fetcher(client, PlaceSetSearchDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePlaceSetSearchQuery.getKey = (variables) => ['PlaceSetSearch.infinite', variables];
;
export const PostCountDocument = `
    query PostCount($page_config__medium__in: [String], $scheduled_for__gte: String, $scheduled_for__lte: String, $publishing_status__in: [PostStatusEnum!], $kind__in: [PostDisplayKindEnum!], $id: Int, $archived: Boolean, $error: Int, $external_id: String, $favorite: Boolean, $id__in: [Int!], $is_instagram_clip: Boolean, $is_instagram_story: Boolean, $is_vk_story: Boolean, $is_ok_story: Boolean, $page_config__in: [Int!], $page_config__group__in: [Int!]) {
  post_count(
    page_config__medium__in: $page_config__medium__in
    scheduled_for__gte: $scheduled_for__gte
    scheduled_for__lte: $scheduled_for__lte
    publishing_status__in: $publishing_status__in
    kind__in: $kind__in
    id: $id
    archived: $archived
    error: $error
    external_id: $external_id
    favorite: $favorite
    id__in: $id__in
    is_instagram_clip: $is_instagram_clip
    is_instagram_story: $is_instagram_story
    is_vk_story: $is_vk_story
    is_ok_story: $is_ok_story
    page_config__in: $page_config__in
    page_config__group__in: $page_config__group__in
  ) {
    published
    total
    archived
    error
    count_max
    scheduled
  }
}
    `;
export const usePostCountQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['PostCount'] : ['PostCount', variables], fetcher(client, PostCountDocument, variables, headers), options);
usePostCountQuery.getKey = (variables) => variables === undefined ? ['PostCount'] : ['PostCount', variables];
;
export const useInfinitePostCountQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['PostCount.infinite'] : ['PostCount.infinite', variables], (metaData) => { var _a; return fetcher(client, PostCountDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostCountQuery.getKey = (variables) => variables === undefined ? ['PostCount.infinite'] : ['PostCount.infinite', variables];
;
export const PostCountDailyDocument = `
    query PostCountDaily($external_id: String, $page_config__medium__in: [String], $scheduled_for__gte: String!, $scheduled_for__lte: String!, $publishing_status__in: [PostStatusEnum!], $kind__in: [PostDisplayKindEnum!], $archived: Boolean, $page_config__group__in: [Int!], $id: Int, $error: Int, $favorite: Boolean, $id__in: [Int!], $is_instagram_clip: Boolean, $is_instagram_story: Boolean, $is_vk_story: Boolean, $is_ok_story: Boolean, $page_config__in: [Int!]) {
  post_count_daily(
    external_id: $external_id
    page_config__medium__in: $page_config__medium__in
    scheduled_for__gte: $scheduled_for__gte
    scheduled_for__lte: $scheduled_for__lte
    publishing_status__in: $publishing_status__in
    kind__in: $kind__in
    archived: $archived
    page_config__group__in: $page_config__group__in
    id: $id
    error: $error
    favorite: $favorite
    id__in: $id__in
    is_instagram_clip: $is_instagram_clip
    is_instagram_story: $is_instagram_story
    is_vk_story: $is_vk_story
    is_ok_story: $is_ok_story
    page_config__in: $page_config__in
  ) {
    count
    day
  }
}
    `;
export const usePostCountDailyQuery = (client, variables, options, headers) => useQuery(['PostCountDaily', variables], fetcher(client, PostCountDailyDocument, variables, headers), options);
usePostCountDailyQuery.getKey = (variables) => ['PostCountDaily', variables];
;
export const useInfinitePostCountDailyQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['PostCountDaily.infinite', variables], (metaData) => { var _a; return fetcher(client, PostCountDailyDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostCountDailyQuery.getKey = (variables) => ['PostCountDaily.infinite', variables];
;
export const PostExternalUrlDocument = `
    query PostExternalUrl($page_name: String!, $page_screen_name: String, $page_type: PageType!, $page_medium: Medium!, $post_external_id: String!, $post_type: PostDisplayKindEnum, $page_external_id: String!) {
  post_external_url(
    page_name: $page_name
    page_screen_name: $page_screen_name
    page_type: $page_type
    page_medium: $page_medium
    post_external_id: $post_external_id
    post_type: $post_type
    page_external_id: $page_external_id
  ) {
    url
  }
}
    `;
export const usePostExternalUrlQuery = (client, variables, options, headers) => useQuery(['PostExternalUrl', variables], fetcher(client, PostExternalUrlDocument, variables, headers), options);
usePostExternalUrlQuery.getKey = (variables) => ['PostExternalUrl', variables];
;
export const useInfinitePostExternalUrlQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['PostExternalUrl.infinite', variables], (metaData) => { var _a; return fetcher(client, PostExternalUrlDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostExternalUrlQuery.getKey = (variables) => ['PostExternalUrl.infinite', variables];
;
export const PostExternalUrlSetDocument = `
    query PostExternalUrlSet($post_set: [PostExternalUrlSetArgs!]!) {
  post_external_url_set(post_set: $post_set) {
    page_name
    post_external_id
    page_screen_name
    post_external_url
    page_type
    post_type
    page_medium
    page_external_id
  }
}
    `;
export const usePostExternalUrlSetQuery = (client, variables, options, headers) => useQuery(['PostExternalUrlSet', variables], fetcher(client, PostExternalUrlSetDocument, variables, headers), options);
usePostExternalUrlSetQuery.getKey = (variables) => ['PostExternalUrlSet', variables];
;
export const useInfinitePostExternalUrlSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['PostExternalUrlSet.infinite', variables], (metaData) => { var _a; return fetcher(client, PostExternalUrlSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostExternalUrlSetQuery.getKey = (variables) => ['PostExternalUrlSet.infinite', variables];
;
export const PostProjectDocument = `
    query PostProject($id: Int!) {
  post_project(id: $id) {
    id
    audio_set {
      artist
      duration
      external_id
      id
      owner_id
      title
    }
    text
    text_original
    title
    topics
    post_set {
      id
      error
      archive_at
      is_draft
      comment {
        text
        archive_at
      }
      scheduled_for
      publishing_status
      page_config {
        id
        external_id
        medium
        name
        pageconfigaccount_set {
          id
          has_publish_permission
          priority
          account {
            id
            credential {
              id
              account_page {
                id
                name
                extra_data {
                  logo
                }
              }
            }
          }
          updated_at
        }
        group {
          id
          name
          post_time_set {
            id
            weekday
            minute
          }
          templates {
            comment {
              order
              placement
              hashtagsOptional
              hashtagsRequired
              isHashtagsRequiredEnabled
              limit
            }
            post {
              order
              placement
              hashtagsOptional
              hashtagsRequired
              isHashtagsRequiredEnabled
              limit
            }
            signs {
              id
              name
              text
            }
          }
          utm {
            id
            is_enabled
          }
          watermark {
            id
          }
        }
        page {
          id
          name
          extra_data {
            logo
            screen_name
          }
          type
        }
        post_time_set {
          id
          weekday
          minute
        }
        watermark {
          id
        }
        utm {
          id
          is_enabled
        }
      }
    }
    uploads {
      id
      mimetype
      url
      thumb
      video_cover {
        id
        thumb
        url
      }
      video_title
      usertags {
        pivot
        position
        profile_pic_url
        user_id
        username
        rotation
      }
    }
    link_url
    copyright_link
    place {
      id
      external_id
      external_id_source
      name
      address
      lat
      lng
    }
    poll {
      id
      question
      variants {
        id
        title
      }
      anonymous_allow_vote
      result_after_voting
      single_choices
    }
    inline_buttons {
      url
      text
    }
    disable_watermark
    notify_on_publishing_success
    disable_comments
    is_advert
    paid_subscribers_only_period
    is_hide_on_archive
    disable_feed_preview
    as_note
    as_carousel
    pin_post
    disable_link_snippet
    disable_utm_generator
    post_link_in_profile
    privacy_level
    youtube_privacy_status
    disable_duet
    disable_stitch
    ...PostProjectOverrides
  }
}
    ${PostProjectOverridesFragmentDoc}`;
export const usePostProjectQuery = (client, variables, options, headers) => useQuery(['PostProject', variables], fetcher(client, PostProjectDocument, variables, headers), options);
usePostProjectQuery.getKey = (variables) => ['PostProject', variables];
;
export const useInfinitePostProjectQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['PostProject.infinite', variables], (metaData) => { var _a; return fetcher(client, PostProjectDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostProjectQuery.getKey = (variables) => ['PostProject.infinite', variables];
;
export const PostProjectSetDailyDocument = `
    query PostProjectSetDaily($cursor: String, $post_set__pageconfig__socialpagegroup: Int, $post_set__scheduled_for__date: String, $ordering: String, $page_size: Int, $is_draft: Boolean, $favorite: Boolean) {
  post_project_set_daily(
    cursor: $cursor
    post_set__pageconfig__socialpagegroup: $post_set__pageconfig__socialpagegroup
    post_set__scheduled_for__date: $post_set__scheduled_for__date
    ordering: $ordering
    page_size: $page_size
    is_draft: $is_draft
    favorite: $favorite
  ) {
    edges {
      node {
        favorite
        post_set {
          archived
          archive_at
          id
          external_id
          scheduled_for
          is_draft
          comment {
            archive_at
            error
            is_archived
            text
            id
          }
          error
          display_kind
          display_page_logo_url
          display_page_title
          publishing_status
          organization {
            id
          }
          favorite
          page_config {
            external_id
            name
            medium
            group {
              id
            }
            page {
              extra_data {
                screen_name
              }
              name
              type
            }
          }
          share
        }
        text
        text_original
        place {
          id
          name
          address
        }
        editor_format
        link_url
        copyright_link
        poll {
          id
          question
          variants {
            title
          }
        }
        id
        uploads {
          id
          thumb
          mimetype
          url
          mimetype_original
          is_processing
          video_cover {
            thumb
            url
          }
        }
        audio_set {
          id
          title
          artist
        }
        inline_buttons {
          url
          text
        }
        ...PostProjectOverrides
      }
    }
    page_info {
      cursor_next
      cursor_previous
    }
  }
}
    ${PostProjectOverridesFragmentDoc}`;
export const usePostProjectSetDailyQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['PostProjectSetDaily'] : ['PostProjectSetDaily', variables], fetcher(client, PostProjectSetDailyDocument, variables, headers), options);
usePostProjectSetDailyQuery.getKey = (variables) => variables === undefined ? ['PostProjectSetDaily'] : ['PostProjectSetDaily', variables];
;
export const useInfinitePostProjectSetDailyQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['PostProjectSetDaily.infinite'] : ['PostProjectSetDaily.infinite', variables], (metaData) => { var _a; return fetcher(client, PostProjectSetDailyDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostProjectSetDailyQuery.getKey = (variables) => variables === undefined ? ['PostProjectSetDaily.infinite'] : ['PostProjectSetDaily.infinite', variables];
;
export const PostSetDocument = `
    query PostSet($favorite: Boolean, $id__in: [Int!], $is_instagram_clip: Boolean, $is_instagram_story: Boolean, $is_vk_story: Boolean, $is_ok_story: Boolean, $page_config__in: [Int!], $page_config__group__in: [Int!], $page_config__medium__in: [String], $scheduled_for__gte: String, $scheduled_for__lte: String, $publishing_status__in: [PostStatusEnum!], $kind__in: [PostDisplayKindEnum!], $cursor: String, $ordering: String, $error: Int, $id: Int, $external_id: String, $archived: Boolean) {
  post_set(
    favorite: $favorite
    id__in: $id__in
    is_instagram_clip: $is_instagram_clip
    is_instagram_story: $is_instagram_story
    is_vk_story: $is_vk_story
    is_ok_story: $is_ok_story
    page_config__in: $page_config__in
    page_config__group__in: $page_config__group__in
    page_config__medium__in: $page_config__medium__in
    scheduled_for__gte: $scheduled_for__gte
    scheduled_for__lte: $scheduled_for__lte
    publishing_status__in: $publishing_status__in
    kind__in: $kind__in
    cursor: $cursor
    ordering: $ordering
    error: $error
    id: $id
    external_id: $external_id
    archived: $archived
  ) {
    edges {
      node {
        archived
        archive_at
        id
        scheduled_for
        is_draft
        comment {
          archive_at
          error
          id
          is_archived
          text
        }
        comment_set {
          id
          status
          scheduled_for
          external_id
          archive_at
          commentproject {
            text
          }
        }
        error
        external_id
        display_kind
        display_page_logo_url
        display_page_title
        publishing_status
        organization {
          id
        }
        favorite
        page_config {
          external_id
          id
          name
          medium
          page {
            extra_data {
              screen_name
            }
            name
            type
          }
        }
        project {
          text
          place {
            id
            name
            address
          }
          editor_format
          link_url
          poll {
            id
            question
            variants {
              title
            }
          }
          id
          uploads {
            id
            thumb
            mimetype
            url
            mimetype_original
            is_processing
            video_cover {
              thumb
              url
            }
          }
          audio_set {
            id
            title
            artist
          }
          post_set {
            page_config {
              medium
            }
          }
        }
        share
      }
    }
    page_info {
      cursor_next
      cursor_previous
    }
  }
}
    `;
export const usePostSetQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['PostSet'] : ['PostSet', variables], fetcher(client, PostSetDocument, variables, headers), options);
usePostSetQuery.getKey = (variables) => variables === undefined ? ['PostSet'] : ['PostSet', variables];
;
export const useInfinitePostSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['PostSet.infinite'] : ['PostSet.infinite', variables], (metaData) => { var _a; return fetcher(client, PostSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostSetQuery.getKey = (variables) => variables === undefined ? ['PostSet.infinite'] : ['PostSet.infinite', variables];
;
export const PostsExportDocument = `
    query PostsExport($external_id: String, $page_config__medium__in: [String], $scheduled_for__gte: String, $scheduled_for__lte: String, $publishing_status__in: [PostStatusEnum!], $kind__in: [PostDisplayKindEnum!], $archived: Boolean, $id: Int, $page_config__group__in: [Int!], $error: Int, $favorite: Boolean, $id__in: [Int!], $is_instagram_clip: Boolean, $is_instagram_story: Boolean, $is_vk_story: Boolean, $is_ok_story: Boolean, $page_config__in: [Int!]) {
  posts_export(
    external_id: $external_id
    page_config__medium__in: $page_config__medium__in
    scheduled_for__gte: $scheduled_for__gte
    scheduled_for__lte: $scheduled_for__lte
    publishing_status__in: $publishing_status__in
    kind__in: $kind__in
    archived: $archived
    id: $id
    page_config__group__in: $page_config__group__in
    error: $error
    favorite: $favorite
    id__in: $id__in
    is_instagram_clip: $is_instagram_clip
    is_instagram_story: $is_instagram_story
    is_vk_story: $is_vk_story
    is_ok_story: $is_ok_story
    page_config__in: $page_config__in
  ) {
    link
  }
}
    `;
export const usePostsExportQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['PostsExport'] : ['PostsExport', variables], fetcher(client, PostsExportDocument, variables, headers), options);
usePostsExportQuery.getKey = (variables) => variables === undefined ? ['PostsExport'] : ['PostsExport', variables];
;
export const useInfinitePostsExportQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['PostsExport.infinite'] : ['PostsExport.infinite', variables], (metaData) => { var _a; return fetcher(client, PostsExportDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfinitePostsExportQuery.getKey = (variables) => variables === undefined ? ['PostsExport.infinite'] : ['PostsExport.infinite', variables];
;
export const SocialPageGroupSetDocument = `
    query SocialPageGroupSet($label: [String!], $all_organization_contexts: Boolean, $all_participated_organization_contexts: Boolean, $id__in: [Int!]) {
  social_page_group_set(
    label: $label
    all_organization_contexts: $all_organization_contexts
    all_participated_organization_contexts: $all_participated_organization_contexts
    id__in: $id__in
  ) {
    id
    name
    pageconfig_set {
      ...SocialPageGroupPageConfig
    }
    organization {
      ...SocialPageGroupOrganization
    }
    is_locked_for_update
    organization_after_update {
      id
    }
    ...SocialPageGroupSettings
  }
}
    ${SocialPageGroupPageConfigFragmentDoc}
${SocialPageGroupOrganizationFragmentDoc}
${SocialPageGroupSettingsFragmentDoc}`;
export const useSocialPageGroupSetQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['SocialPageGroupSet'] : ['SocialPageGroupSet', variables], fetcher(client, SocialPageGroupSetDocument, variables, headers), options);
useSocialPageGroupSetQuery.getKey = (variables) => variables === undefined ? ['SocialPageGroupSet'] : ['SocialPageGroupSet', variables];
;
export const useInfiniteSocialPageGroupSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['SocialPageGroupSet.infinite'] : ['SocialPageGroupSet.infinite', variables], (metaData) => { var _a; return fetcher(client, SocialPageGroupSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteSocialPageGroupSetQuery.getKey = (variables) => variables === undefined ? ['SocialPageGroupSet.infinite'] : ['SocialPageGroupSet.infinite', variables];
;
export const UploadSetDocument = `
    query UploadSet($id__in: [Int!]!) {
  upload_set(id__in: $id__in) {
    id
    is_processing
    mimetype
    mimetype_original
    thumb
    url
  }
}
    `;
export const useUploadSetQuery = (client, variables, options, headers) => useQuery(['UploadSet', variables], fetcher(client, UploadSetDocument, variables, headers), options);
useUploadSetQuery.getKey = (variables) => ['UploadSet', variables];
;
export const useInfiniteUploadSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['UploadSet.infinite', variables], (metaData) => { var _a; return fetcher(client, UploadSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteUploadSetQuery.getKey = (variables) => ['UploadSet.infinite', variables];
;
export const VkAudioSetSearchDocument = `
    query VkAudioSetSearch($query: String!, $count: Int) {
  vk_audio_set_search(query: $query, count: $count) {
    artist
    owner_id
    title
    duration
    external_id
  }
}
    `;
export const useVkAudioSetSearchQuery = (client, variables, options, headers) => useQuery(['VkAudioSetSearch', variables], fetcher(client, VkAudioSetSearchDocument, variables, headers), options);
useVkAudioSetSearchQuery.getKey = (variables) => ['VkAudioSetSearch', variables];
;
export const useInfiniteVkAudioSetSearchQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(['VkAudioSetSearch.infinite', variables], (metaData) => { var _a; return fetcher(client, VkAudioSetSearchDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteVkAudioSetSearchQuery.getKey = (variables) => ['VkAudioSetSearch.infinite', variables];
;
export const WatermarkSetDocument = `
    query WatermarkSet($id__in: [Int!]) {
  watermark_set(id__in: $id__in) {
    position {
      axis_start_pos
      calculate
      horizontal
      vertical
    }
    id
    size {
      height
      calculate
      width
    }
    name
    upload {
      id
      is_processing
      mimetype
      mimetype_original
      url
      thumb
    }
    opacity
    original_height
    original_width
    thumbnail_height
    thumbnail_width
    text_source {
      italic
      color
      align
      bold
      text
      font
    }
  }
}
    `;
export const useWatermarkSetQuery = (client, variables, options, headers) => useQuery(variables === undefined ? ['WatermarkSet'] : ['WatermarkSet', variables], fetcher(client, WatermarkSetDocument, variables, headers), options);
useWatermarkSetQuery.getKey = (variables) => variables === undefined ? ['WatermarkSet'] : ['WatermarkSet', variables];
;
export const useInfiniteWatermarkSetQuery = (pageParamKey, client, variables, options, headers) => useInfiniteQuery(variables === undefined ? ['WatermarkSet.infinite'] : ['WatermarkSet.infinite', variables], (metaData) => { var _a; return fetcher(client, WatermarkSetDocument, Object.assign(Object.assign({}, variables), ((_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {})), headers)(); }, options);
useInfiniteWatermarkSetQuery.getKey = (variables) => variables === undefined ? ['WatermarkSet.infinite'] : ['WatermarkSet.infinite', variables];
;
//# sourceMappingURL=index.js.map